import {Grid, Table, TableBody,	TableCell, TableRow, TextField, Link, Dialog, AppBar, Toolbar, Tooltip, Typography, IconButton} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import Reports from './Reports';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import './report.less';
import DateFnsUtils from '@date-io/date-fns';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import { Switch } from '../common/Switch';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';
import PageHeader from '../common/PageHeader';
import ReportButtons from './ReportButtons';
import { EnhancedTableHead, GenerateAbsoluteURL, removeDuplicates,	orderBy, IsAutoRunPagesEnabled, UpdateColumnWithConfiguration} from '../../utils/helper';
import AdvancedFilter from './AdvancedFilter';
import { generateString, getMultilevelGroupedData } from '../../utils/generic';
import { getFormattedValues } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TableWithPaginations from './TableWithPaginations';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { readOnlyManagementFeeColumns, ExpenseColumns, propertyColumnsPTFDetailReport} from '../../constants/MockData';
import GridTable from '../common/Table/Table';
import { Visibility } from '@material-ui/icons';

let temcurrentGroupedRow = [];

// Head cells that will not be applicable for groupings
const headCells = [
  {
		key: 'PTF Number',
		value: 'ptfNumber',
		ssrsReport: 'PTF Number',
		numeric: false,
		disablePadding: false,
		label: 'PTF Number',
		type: 'Link',
		id: 'ptfNumber',
		order: 6
	},
  {
    key: 'Service Type(s)',
    value: 'serviceTypeName',
    id: 'serviceTypeName',
    ssrsReport: 'ServiceTypeName',
    numeric: false,
    disablePadding: false,
    label: 'Service Type(s)',
    type: 'Text',
    order: 7
  },
  {
    key: 'Property Type(s)',
    value: 'propertyType',
    id: 'propertyType',
    ssrsReport: 'PropertyType',
    numeric: false,
    disablePadding: false,
    label: 'Property Type(s)',
    type: 'Text',
    order: 8
  },
  {
    key: 'Property Sub Type(s)',
    value: 'propertySubType',
    id: 'propertySubType',
    ssrsReport: 'PropertySubType',
    numeric: false,
    disablePadding: false,
    label: 'Property Sub Type(s)',
    type: 'Text',
    order: 9
  },
  {
    key: 'Property(s)',
    value: 'propertyName',
    id: 'propertyName',
    ssrsReport: 'PropertyName',
    numeric: false,
    disablePadding: false,
    label: 'Property(s)',
    type: 'Text',
    order: 10
  },
  {
    key: 'Management Fee(s)',
    value: 'propertyManagementFee',
    id: 'propertyManagementFee',
    ssrsReport: 'PropertyManagementFee',
    numeric: false,
    disablePadding: false,
    label: 'Management Fee(s)',
    type: 'Text',
    order: 11
  },
  {
    key: 'Billable Expense(s)',
    value: 'propertyBillableExpense',
    id: 'propertyBillableExpense',
    ssrsReport: 'PropertyBillableExpense',
    numeric: false,
    disablePadding: false,
    label: 'Billable Expense(s)',
    type: 'Text',
    order: 12
  },
  {
    key: 'Service(s) Start Date',
    value: 'ptfStartDate',
    id: 'ptfStartDate',
    ssrsReport: 'PtfStartDate',
    numeric: false,
    disablePadding: false,
    label: 'Service(s) Start Date',
    type: 'Text',
    format: 'Date',
    order: 13
  },
  {
    key: 'Service(s) End Date',
    value: 'ptfEndDate',
    id: 'ptfEndDate',
    ssrsReport: 'PtfEndDate',
    numeric: false,
    disablePadding: false,
    label: 'Service(s) End Date',
    type: 'Text',
    format: 'Date',
    order: 14
  },
  {
    key: 'Allocated Employee Count',
    value: 'noOfEmployees',
    id: 'noOfEmployees',
    ssrsReport: 'NoOfEmployees',
    numeric: true,
    disablePadding: false,
    label: 'Allocated Employee Count',
    type: 'Number',
    order: 15
  },
  {
    key: 'Engineer Hour Billing',
    value: 'isEngineerHourBilling',
    id: 'isEngineerHourBilling',
    ssrsReport: 'IsEngineerHourBilling',
    numeric: false,
    disablePadding: false,
    label: 'Engineer Hour Billing',
    type: 'Text',
    order: 16
  },
  {
    key: 'Engineer Hourly Billing Rate',
    value: 'engineerHourBillingRate',
    id: 'engineerHourBillingRate',
    ssrsReport: 'EngineerHourBillingRate',
    numeric: true,
    disablePadding: false,
    label: 'Engineer Hourly Billing Rate',
    type: 'Number',
    order: 17
  },
  {
    key: 'Engineer Overtime Hourly Billing Rate',
    value: 'engineerOvertimeHourBillingRate',
    id: 'engineerOvertimeHourBillingRate',
    ssrsReport: 'EngineerOvertimeHourBillingRate',
    numeric: true,
    disablePadding: false,
    label: 'Engineer Overtime Hourly Billing Rate',
    type: 'Number',
    order: 18
  }
];
export default class PTFDetailReport extends Component {
	// Constructor to define the state
	constructor(props) {
			super(props);
			this.state = {
					showMain: false,					
					reportData: [],
					showReport: false,
					marketMasterData: [],
          legalEntityMasterData: [],
          clientListingMasterData: [],
          propertyMasterData: [],
          transitionTypeListingData: [],
          propertyTypeMasterData: [],
          propertySubTypeMasterData: [],
          serviceTypeMasterData: [],
          statusMasterData: [],
					market: [{ marketName: 'All' }],
          legalEntity: [{ customerName: 'All' }],
          client: [{ clientName: 'All' }],
          property: [{ propertyName: 'All' }],
          transitionType: [{transitionTypeName: 'All'}],
          propertyType: [{propertyTypeName: 'All'}],
          propertySubType: [{propertySubTypeName: 'All'}],
          serviceType: [{serviceType: 'All'}],
          approvalStatus: [{approvalStatus: 'All'}],
					openSlidingPanel: false,
					isAutoRunEnabled: IsAutoRunPagesEnabled(),
					isSubmitButtonClicked: false,
					serviceStartDateFrom: null,
					serviceStartDateTo: null,
					serviceEndDateFrom: null,
					serviceEndDateTo: null,
          showInActivePTF: true,
          ptfNumber: null,
          openDialog: false,
          dialogTitle: '',
          showManagementFeeDetails: false,
          showBillableExpenseDetails: false,
          reloadDialogTable: false,
					advanceFilterConfig: {
						groupBy: {
							masterData: [
								{
									key: 'Client Name',
									value: 'clientName',
									ssrsReport: 'ClientName',
									numeric: false,
									disablePadding: false,
									label: 'Client',
									type: 'Text',
									id: 'clientName',
									order: 2
								},								
								{
									key: 'Legal Entity',
									value: 'assignmentName',
									id: 'assignmentName',
									ssrsReport: 'LegalEntity',
									numeric: false,
									disablePadding: false,
									label: 'Legal Entity',
									type: 'Text',
									order: 3
								},
								{
									key: 'Transition Type',
									value: 'transitionType',
									id: 'transitionType',
									ssrsReport: 'TransitionType',
									numeric: false,
									disablePadding: false,
									label: 'Transition Type',
									type: 'Text',
									order: 4
								},
                {
									key: 'Status',
									value: 'approvalStatus',
									id: 'approvalStatus',
									ssrsReport: 'ApprovalStatus',
									numeric: false,
									disablePadding: false,
									label: 'Status',
									type: 'Text',
									order: 5
								},
								// {
								// 	key: 'Service Type(s)',
								// 	value: 'serviceTypeName',
								// 	id: 'serviceTypeName',
								// 	ssrsReport: 'ServiceTypeName',
								// 	numeric: false,
								// 	disablePadding: false,
								// 	label: 'Service Type(s)',
								// 	type: 'Text',
								// 	order: 6
								// },
								// {
								// 	key: 'Property Type(s)',
								// 	value: 'propertyType',
								// 	id: 'propertyType',
								// 	ssrsReport: 'PropertyType',
								// 	numeric: false,
								// 	disablePadding: false,
								// 	label: 'Property Type(s)',
								// 	type: 'Text',
								// 	order: 7
								// },
								// {
								// 	key: 'Property Sub Type(s)',
								// 	value: 'propertySubType',
								// 	id: 'propertySubType',
								// 	ssrsReport: 'PropertySubType',
								// 	numeric: false,
								// 	disablePadding: false,
								// 	label: 'Property Sub Type(s)',
								// 	type: 'Text',
								// 	order: 8
								// },
								// {
								// 	key: 'Property(s)',
								// 	value: 'propertyName',
								// 	id: 'propertyName',
								// 	ssrsReport: 'PropertyName',
								// 	numeric: false,
								// 	disablePadding: false,
								// 	label: 'Property(s)',
								// 	type: 'Text',
								// 	order: 9
								// },
								// {
								// 	key: 'Service(s) Start Date',
								// 	value: 'ptfStartDate',
								// 	id: 'ptfStartDate',
								// 	ssrsReport: 'PtfStartDate',
								// 	numeric: false,
								// 	disablePadding: false,
								// 	label: 'Service(s) Start Date',
								// 	type: 'Text',
                //   format: 'Date',
								// 	order: 10
								// },
								// {
								// 	key: 'Service(s) End Date',
								// 	value: 'ptfEndDate',
								// 	id: 'ptfEndDate',
								// 	ssrsReport: 'PtfEndDate',
								// 	numeric: false,
								// 	disablePadding: false,
								// 	label: 'Service(s) End Date',
								// 	type: 'Text',
                //   format: 'Date',
								// 	order: 10
								// }								
							],
							selected: [{
								key: 'Market',
								value: 'marketName',
								id: 'marketName',
								ssrsReport: 'MarketName',
								numeric: false,
								disablePadding: false,
								label: 'Market',
								type: 'Text',
								order: 1
							}]
						},
						selectedDate: {},
						suppressGraph: false,
						suppressZero: false,
						summaryRows: false,
						showZeroNGraph: false,
						serviceStartDateFrom: null,
						serviceStartDateTo: null,
						serviceEndDateFrom: null,
						serviceEndDateTo: null
					},
          order: 'asc',
          orderBy: 'marketName',
			}
      this.baseState = this.state;  
	}

	// Method is used to get data before components are mounted
	componentDidMount() {
		this.GetMasterData();
	}

	// Go to Report list page
	goBack = () => {
		this.setState({
			showMain: true
		});
	};

	// Get Master data to fill filters
	GetMasterData = () => {
		this._asyncRequest = apiBatchRequest([
			{
				url: API_URL.Market.GetMarketMasterdata,
				key: 'marketMasterData'
			},
      {
        url: API_URL.Transition.GetCustomerListingData,
        key: 'legalEntityMasterData',
        fromCache: true,
        duration: 1
      },
      {
        url: API_URL.Transition.GetClientListingData,
        key: 'clientListingMasterData',
        fromCache: true,
        duration: 1
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Transition.GetTransitionTypeListingData,
        key: 'transitionTypeListingData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: 'propertyTypeMasterData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Property.GetPropertySubType,
        key: 'propertySubTypeMasterData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Assignments.GetServiceTypeMasterData,
        key: 'serviceTypeMasterData',
        fromCache: false,
        duration: 60
      },
      {
        url: API_URL.Allocation.GetApprovalStatus,
        key: 'statusMasterData',
        duration: 60
      } 
		])
		.then(
			({
				marketMasterData, legalEntityMasterData, clientListingMasterData, propertyMasterData, transitionTypeListingData, propertyTypeMasterData, propertySubTypeMasterData, serviceTypeMasterData, statusMasterData
			}) => {
				this._asyncRequest = null;
				if (marketMasterData.success !== true) {
					ShowToast(
						commonLabels.somethingWrong,
						toastType.ERROR,
						5000,
						500,
						'Server error'
					);
				}
				this.setState({
					marketMasterData: removeDuplicates(marketMasterData.data || [], 'marketName'),
          legalEntityMasterData: removeDuplicates(legalEntityMasterData.data || [], 'customerName'),
          clientListingMasterData: removeDuplicates(clientListingMasterData.data || [], 'clientName'),
          propertyMasterData: removeDuplicates(propertyMasterData.data || [], 'propertyName'),
          transitionTypeListingData: removeDuplicates(transitionTypeListingData.data || [], 'transitionTypeName'),
          propertyTypeMasterData: removeDuplicates(propertyTypeMasterData.data || [], 'propertyTypeName'),
          propertySubTypeMasterData: removeDuplicates(propertySubTypeMasterData.data || [], 'propertySubTypeName'),
          serviceTypeMasterData: removeDuplicates(serviceTypeMasterData.data || [], 'serviceType'),
          statusMasterData: removeDuplicates((statusMasterData.data || []).filter(x=> x.isPTFStatus === true) || [], 'approvalStatus')
				}, () => {
						if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
							this.handleSubmit();
						}            
				});
			}
			)
			.catch(() => {
					this._asyncRequest = null;
			});
	};

	// Date change event of calendar
  handleDateChange = (date, name) => {
    // if (date?.toString() !== 'Invalid Date') {
      if (date === null) {
        const { advanceFilterConfig } = this.state;
		    advanceFilterConfig[name] = date;
		    this.setState({advanceFilterConfig, [name]: date });
      } else {
        const { advanceFilterConfig } = this.state;
		    advanceFilterConfig[name] = moment(date).format(DateFormat);
		    this.setState({advanceFilterConfig, [name]: moment(date).format(DateFormat) });
      }      
    // }
  };

	// Get report data based on selected filters
  GetPTFDetailReport = () => {
    const { market, serviceStartDateFrom, serviceStartDateTo, serviceEndDateFrom, serviceEndDateTo, showInActivePTF, ptfNumber,
    client, legalEntity, property, propertyType, propertySubType, transitionType, approvalStatus, serviceType } = this.state;
    const marketId = _.cloneDeep(market.map((x) => x.marketId));    
    const clientId = _.cloneDeep(client.map((x) => x.clientId));
    const legalEntityId = _.cloneDeep(legalEntity.map((x) => x.customerId));
    const propertyTypeId = _.cloneDeep(propertyType.map((x) => x.propertyTypeId));
    const propertySubTypeId = _.cloneDeep(propertySubType.map((x) => x.propertySubTypeId));    
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const transitionTypeId = _.cloneDeep(transitionType.map((x) => x.transitionTypeId));
    const approvalStatusId = _.cloneDeep(approvalStatus.map((x) => x.approvalStatusId));
    const serviceTypeId = _.cloneDeep(serviceType.map((x) => x.serviceTypeId));
      
    const params = {
			serviceStartDateFrom: serviceStartDateFrom,
			serviceStartDateTo: serviceStartDateTo,
			serviceEndDateFrom: serviceEndDateFrom,
			serviceEndDateTo: serviceEndDateTo,
      showInActivePTF: showInActivePTF,
      ptfNumber: (ptfNumber === null || ptfNumber === '') ? '0' : ptfNumber,
      marketId: marketId.join('|') === '' ? '0' : marketId.join('|'),
      clientId: clientId.join('|') === '' ? '0' : clientId.join('|'),
      legalEntityId: legalEntityId.join('|') === '' ? '0' : legalEntityId.join('|'),
      propertyTypeId: propertyTypeId.join('|') === '' ? '0' : propertyTypeId.join('|'),
      propertySubTypeId: propertySubTypeId.join('|') === '' ? '0' : propertySubTypeId.join('|'),
      propertyId: propertyId.join('|') === '' ? '0' : propertyId.join('|'),
      transitionTypeId: transitionTypeId.join('|') === '' ? '0' : transitionTypeId.join('|'),
      approvalStatusId: approvalStatusId.join('|') === '' ? '0' : approvalStatusId.join('|'),
      serviceTypeId: serviceTypeId.join('|') === '' ? '0' : serviceTypeId.join('|'),
    };

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetPTFDetailReport,
        params,
        key: 'reportData'
      }
    ])
      .then(({ reportData }) => {
        this._asyncRequest = null;
        if (reportData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          reportData: this.separatePropertyAddress(reportData.data),
          reportConfig: reportData.config,
          rows: this.getTableRow(reportData.data),
          showReport: true,
          isSubmitButtonClicked: true
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

	// Handle sorting on table columns
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    let rows = [];
    rows = [...rows, ...this.renderTableRow(
      orderBy((this.state.reportData || []), property, isAsc ? 'desc' : 'asc')
    )];
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
      rows
    }, () => {this.forceUpdate();});
  };

	// Render table Data
  renderTable = (rows) => {
    const groupSequence = this.getColumnSequence();
    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={rows.length}
          columnSequence={groupSequence}
          headCells={headCells}
        />
        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

	// Close sliding panel
  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

	// Reset filters and reload report data
  resetPage = () => {    
    const { advanceFilterConfig } = this.state;
    advanceFilterConfig.serviceStartDateFrom = null;
    advanceFilterConfig.serviceStartDateTo = null;
		advanceFilterConfig.serviceEndDateFrom = null;
    advanceFilterConfig.serviceEndDateTo = null;

    advanceFilterConfig.groupBy = {
      masterData: [
				{
          key: 'Client Name',
          value: 'clientName',
          ssrsReport: 'ClientName',
          numeric: false,
          disablePadding: false,
          label: 'Client',
          type: 'Text',
          id: 'clientName',
          order: 2
        },        
        {
          key: 'Legal Entity',
          value: 'assignmentName',
          id: 'assignmentName',
          ssrsReport: 'LegalEntity',
          numeric: false,
          disablePadding: false,
          label: 'Legal Entity',
          type: 'Text',
          order: 3
        },
        {
          key: 'Transition Type',
          value: 'transitionType',
          id: 'transitionType',
          ssrsReport: 'TransitionType',
          numeric: false,
          disablePadding: false,
          label: 'Transition Type',
          type: 'Text',
          order: 4
        },
        {
          key: 'Status',
          value: 'approvalStatus',
          id: 'approvalStatus',
          ssrsReport: 'ApprovalStatus',
          numeric: false,
          disablePadding: false,
          label: 'Status',
          type: 'Text',
          order: 5
        }
			],
      selected: [{
        key: 'Market',
        value: 'marketName',
        id: 'marketName',
        ssrsReport: 'MarketName',
        numeric: false,
        disablePadding: false,
        label: 'Market',
        type: 'Text',
        order: 1
      }]
    };
    this.setState({
      ...this.baseState,
      ptfNumber: '',
      isSubmitButtonClicked: false,
      advanceFilterConfig
    }, this.GetMasterData());
  };

	// Click event on Run Report button
  handleSubmit = () => {
    this.GetPTFDetailReport();
  };

	// Open sliding panel
  handleClickOpen = () => {
    this.setState({
      openSlidingPanel: true
    });
  };

	// Print report
  handlePrintClick = () => {
    this.setState(
      {
        printPage: true
      },
      window.print()
    );
  };

  // Click event of switch button "Show InActive Property Transitions". 
  // It will set true/false value to the variable showInActivePTF
  // If the value is true, it will show all the Active and InActive PTFs
  // If the value is false, it will show Active PTFs only
  showHideInActivePTF = (checked) => {
    this.setState({ showInActivePTF: checked });
  }

  // Change event of PTF Number filter
  onChangePTFNumber = (event, value) => {
    this.setState({ptfNumber: value});
  }

	// Handle change event of filtered values
  handleChange = (_e, value, name, optionLabel) => {
    if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
        this.setState({ [name]: value });
      } else if ((value || []).find(x => x[optionLabel] === 'All')) {
        this.setState({ [name]: [{ [optionLabel]: 'All' }] });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      value = (value || []).filter(x => x[optionLabel] !== 'All');
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
      }
      this.setState({ [name]: value });
    }
  };

	// Change event of Advanced filters
  onAddvanceFilterChange = (advanceFilterConfig) => {
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false
    }, () => { this.GetPTFDetailReport(); });
  };

	// Get column sequence based on grouping selected on Advanced filters
  getColumnSequence = () => {
    return removeDuplicates(
      [
        ...this.state.advanceFilterConfig.groupBy.selected,
        ...this.state.advanceFilterConfig.groupBy.masterData
      ],
      'key'
    );
  };

	// Adjust column sequence as per grouping selected
  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach((x) => {
      currentGroupedRow.push({ key: x.value });
    });
    return currentGroupedRow;
  };

	// Render row wise data records
  renderTableRow = (data, onlydata = false) => {
    temcurrentGroupedRow = [];
    return this.renderTableCell(
      getMultilevelGroupedData(
        data,
        this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value)
      ),
      onlydata,
      []
    );
  };

	// Render table cells with formatted values
  renderTableCell = (groupedData, onlydata, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const sequence = this.getColumnSequence();

    groupedData.forEach((d, i) => {
      let column1 = (temcurrentGroupedRow.find(x => x.key === sequence[0].value) || {})?.value || null;
      let column2 = (temcurrentGroupedRow.find(x => x.key === sequence[1].value) || {})?.value || null;
      let column3 = (temcurrentGroupedRow.find(x => x.key === sequence[2].value) || {})?.value || null;
      let column4 = (temcurrentGroupedRow.find(x => x.key === sequence[3].value) || {})?.value || null;
      let column5 = (temcurrentGroupedRow.find(x => x.key === sequence[4].value) || {})?.value || null;
			// let column6 = (temcurrentGroupedRow.find(x => x.key === sequence[5].value) || {})?.value || null;
			// let column7 = (temcurrentGroupedRow.find(x => x.key === sequence[6].value) || {})?.value || null;
			// let column8 = (temcurrentGroupedRow.find(x => x.key === sequence[7].value) || {})?.value || null;
			// let column9 = (temcurrentGroupedRow.find(x => x.key === sequence[8].value) || {})?.value || null;
			// let column10 = (temcurrentGroupedRow.find(x => x.key === sequence[9].value) || {})?.value || null;
			// let column11 = (temcurrentGroupedRow.find(x => x.key === sequence[10].value) || {})?.value || null;
			// let column12 = (temcurrentGroupedRow.find(x => x.key === sequence[11].value) || {})?.value || null;

      if (d.data !== undefined) {        
        this.renderTableCell(d.data, onlydata, currentGroupedRow, tableCell, rowCount);
      } else {
        const groupColumns = this.state.advanceFilterConfig.groupBy.selected;

        groupColumns?.forEach(g => {
          temcurrentGroupedRow = temcurrentGroupedRow.filter((x) => x.key !== g.value);

          temcurrentGroupedRow.push({ key: g.value, value: d[g.value] });
        });
      }
      const keyvalue = this.adjustColumnSequence(_.cloneDeep(temcurrentGroupedRow));      
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const topBorderClass =
        column1 !== (keyvalue.find(x => x.key === sequence[0].value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';

      const key = d.transitionId + '_' + d.assignmentId + '_' + rowCount + '_' + i;
      if (d.data === undefined) {
        if (onlydata) {
          const rowData = {};
          rowData[sequence[0].value] = getFormattedValues(column1 !== d[sequence[0].value] ? d[sequence[0].value] : '', 'Text', true);
          rowData[sequence[1].value] = getFormattedValues(column2 !== d[sequence[1].value] ? d[sequence[1].value] : '', 'Text', true);
          rowData[sequence[2].value] = getFormattedValues(column3 !== d[sequence[2].value] ? d[sequence[2].value] : '', 'Text', true);
          rowData[sequence[3].value] = getFormattedValues(column4 !== d[sequence[3].value] ? d[sequence[3].value] : '', 'Text', true);
          rowData[sequence[4].value] = getFormattedValues(column5 !== d[sequence[4].value] ? d[sequence[4].value] : '', 'Text', true);
					// rowData[sequence[5].value] = getFormattedValues(column5 !== d[sequence[5].value] ? d[sequence[5].value] : '', 'Text', true);
					// rowData[sequence[6].value] = getFormattedValues(column5 !== d[sequence[6].value] ? d[sequence[6].value] : '', 'Text', true);
					// rowData[sequence[7].value] = getFormattedValues(column5 !== d[sequence[7].value] ? d[sequence[7].value] : '', 'Text', true);
					// rowData[sequence[8].value] = getFormattedValues(column5 !== d[sequence[8].value] ? d[sequence[8].value] : '', 'Text', true);
					// rowData[sequence[9].value] = getFormattedValues(column5 !== d[sequence[9].value] ? d[sequence[9].value] : '', 'Text', true);
					// rowData[sequence[10].value] = getFormattedValues(column5 !== d[sequence[10].value] ? d[sequence[10].value] : '', 'Text', true);
					// rowData[sequence[11].value] = getFormattedValues(column5 !== d[sequence[11].value] ? d[sequence[11].value] : '', 'Text', true);
          // rowData.email = d.email;
          // rowData.hire_Date = d.hire_Date;
        } else {
          tableCell.push(
            <TableRow key={key} className={topBorderClass}>
              <TableCell className={
                evenOddClass +
                topBorderClass
              }>
                {getFormattedValues(column1 !== d[sequence[0].value] && d[sequence[0].value], 'Text')}{' '}
              </TableCell>
              <TableCell
                className={
                  evenOddClass +
                  ((column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[1].value], 'Text')}{' '}
              </TableCell>
              <TableCell
                className={
                  evenOddClass +
                  ((column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[2].value], 'Text')}{' '}
              </TableCell>
              <TableCell
                className={
                  evenOddClass +
                  ((column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[3].value], 'Text')}{' '}
              </TableCell>
              <TableCell
                className={
                  evenOddClass +
                  ((column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[4].value], 'Text')}{' '}
              </TableCell>
							{/* <TableCell
                className={
                  evenOddClass +
                  ((column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[5].value], 'Text')}{' '}
              </TableCell> */}
							{/* <TableCell
                className={
                  evenOddClass +
                  ((column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[6].value], 'Text')}{' '}
              </TableCell>
							<TableCell
                className={
                  evenOddClass +
                  ((column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[7].value], 'Text')}{' '}
              </TableCell>
							<TableCell
                className={
                  evenOddClass +
                  ((column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[8].value], 'Text')}{' '}
              </TableCell>
							<TableCell
                className={
                  evenOddClass +
                  ((column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[9].value], 'Text')}{' '}
              </TableCell>
							<TableCell
                className={
                  evenOddClass +
                  ((column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[10].value], 'Text')}{' '}
              </TableCell>
							<TableCell
                className={
                  evenOddClass +
                  ((column12 !== d[sequence[11].value] || column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value])
                    ? ' rpt-topBorder '
                    : ' ')
                }
              >
                {getFormattedValues((column12 !== d[sequence[11].value] || column11 !== d[sequence[10].value] || column10 !== d[sequence[9].value] || column9 !== d[sequence[8].value] || column8 !== d[sequence[7].value] || column7 !== d[sequence[6].value] || column6 !== d[sequence[5].value] || column5 !== d[sequence[4].value] || column4 !== d[sequence[3].value] || column3 !== d[sequence[2].value] || column2 !== d[sequence[1].value] || column1 !== d[sequence[0].value]) && d[sequence[11].value], 'Text')}{' '}
              </TableCell> */}


              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.ptfNumber === null
                  ? '-'
                  : <Link className='anchor-decoration' 
                      href= {window.location.origin + '/ptfDetail?selectedTransitionId=' + d.transitionId + '&selectedPropertyId=' + d.propertyId + '&selectedClientId=' + d.clientId + '&isCallFromPTFDetailReport=true&readOnly=true'}
                      style = {{ cursor: 'pointer' }} 
                      underline='always'                     
                      target='_blank'
                    >{d.ptfNumber}</Link>}
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.serviceType === null
                  ? '-'
                  : getFormattedValues((d.serviceTypeName || '').split('|'), 'MultiText')}
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.propertyType === null
                  ? '-'
                  : getFormattedValues((d.propertyType || '').split('|'), 'MultiText')}
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.propertySubType === null
                  ? '-'
                  : getFormattedValues((d.propertySubType || '').split('|'), 'MultiText')}
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.propertyName === null
                  ? '-'
                  : <>
                  <div style={{float:'right'}}>
                    <Tooltip title={'Click to view Property Address details'} onClick={() => {this.showPropertyDetails(d.propertyAddress)}}>                        
                      <Visibility fontSize="small" size="small" />
                    </Tooltip>
                  </div>
                  {getFormattedValues((d.propertyName || '').split('|'), 'MultiText')}
                </>
                }
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.propertyManagementFee === null
                  ? '-'
                  : <>
                      <div style={{float:'right'}}>
                        <Tooltip title={'Click to view Management Fee details'} onClick={() => {this.showManagementFee(d.propertyManagementFee)}}>                        
                          <Visibility fontSize="small" size="small" />
                        </Tooltip>
                      </div>
                      {getFormattedValues((d.propertyManagementFee || '').split('|'), 'MultiText')}
                    </>
                }
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.propertyBillableExpense === null
                  ? '-'
                  : <>
                      <div style={{float:'right'}}>
                        <Tooltip title={'Click to view Billable Expense details'} onClick={() => {this.showBillableExpense(d.propertyBillableExpense)}}>
                          <Visibility fontSize="small" size="small" />
                        </Tooltip>
                      </div>
                      {getFormattedValues((d.propertyBillableExpense || '').split('|'), 'MultiText')}
                    </>
                }
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.ptfStartDate === null
                  ? '-'
                  : getFormattedValues(d.ptfStartDate, 'Date')}
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.ptfEndDate === null
                  ? '-'
                  : getFormattedValues(d.ptfEndDate, 'Date')}
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.noOfEmployees === null
                  ? '-'
                  : getFormattedValues(d.noOfEmployees, 'Number')}
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.isEngineerHourBilling === null
                  ? '-'
                  : getFormattedValues(d.isEngineerHourBilling, 'Boolean')}
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.engineerHourBillingRate === null
                  ? '-'
                  : getFormattedValues(d.engineerHourBillingRate, 'Number')}
              </TableCell>
              <TableCell
                className={evenOddClass + 'rpt-topBorder'}
              >
                {d.engineerOvertimeHourBillingRate === null
                  ? '-'
                  : getFormattedValues(d.engineerOvertimeHourBillingRate, 'Number')}
              </TableCell>
            </TableRow>
          );
        }
      }
      rowCount++;
      column1 = (temcurrentGroupedRow.find((x) => x.key === sequence[0].value) || {}).value ?? null;
      column2 = (temcurrentGroupedRow.find((x) => x.key === sequence[1].value) || {}).value ?? null;
      column3 = (temcurrentGroupedRow.find((x) => x.key === sequence[2].value) || {}).value ?? null;
      column4 = (temcurrentGroupedRow.find((x) => x.key === sequence[3].value) || {}).value ?? null;
      column5 = (temcurrentGroupedRow.find((x) => x.key === sequence[4].value) || {}).value ?? null;
			// column6 = (temcurrentGroupedRow.find((x) => x.key === sequence[5].value) || {}).value ?? null;
			// column7 = (temcurrentGroupedRow.find((x) => x.key === sequence[6].value) || {}).value ?? null;
			// column8 = (temcurrentGroupedRow.find((x) => x.key === sequence[7].value) || {}).value ?? null;
			// column9 = (temcurrentGroupedRow.find((x) => x.key === sequence[8].value) || {}).value ?? null;
			// column10 = (temcurrentGroupedRow.find((x) => x.key === sequence[9].value) || {}).value ?? null;
			// column11 = (temcurrentGroupedRow.find((x) => x.key === sequence[10].value) || {}).value ?? null;
			// column12 = (temcurrentGroupedRow.find((x) => x.key === sequence[11].value) || {}).value ?? null;
    });
    return tableCell;
  }

  // Click event of Show Property Address details on Dialog
  showPropertyDetails = (propertyAddress) => {
    // alert(propertyAddress);
    this.setState({openDialog: true, dialogTitle: 'Property Address Details', showPropertyDetails: true, showManagementFeeDetails: false, showBillableExpenseDetails: false, propertyAddressData: propertyAddress});
  }

  // Click event of Show Management Fee on Dialog
  showManagementFee = (propertyManagementFee) => {
    // alert(propertyManagementFee);
    this.setState({openDialog: true, dialogTitle: 'Management Fee Details', showPropertyDetails: false, showManagementFeeDetails: true, showBillableExpenseDetails: false, propertyManagementFee: propertyManagementFee});
  }

  // Click event of Show Billable Expense on Dialog
  showBillableExpense = (propertyBillableExpense) => {
    // alert(propertyBillableExpense);
    this.setState({openDialog: true, dialogTitle: 'Billable Expense Details', showPropertyDetails: false, showManagementFeeDetails: false, showBillableExpenseDetails: true, propertyBillableExpense: propertyBillableExpense});
  }

	// Download report into excel or pdf file based on filters selected
  downloadFile = (fileMimeType, type, isPrint = false) => {
    let { market, serviceStartDateFrom, serviceStartDateTo, serviceEndDateFrom, serviceEndDateTo, showInActivePTF, advanceFilterConfig, 
      ptfNumber, client, legalEntity, propertyType, propertySubType, property, serviceType, approvalStatus, transitionType
    } = this.state;
    const dataValue = [];
		if(serviceStartDateFrom !== null) {
			dataValue.push({key: 'ServiceStartDateFrom', value: moment(serviceStartDateFrom).format(DateFormat)});
		}
		if(serviceStartDateTo !== null) {
			dataValue.push({key: 'ServiceStartDateTo', value: moment(serviceStartDateTo).format(DateFormat)});
		}
		if(serviceEndDateFrom !== null) {
			dataValue.push({key: 'ServiceEndDateFrom', value: moment(serviceEndDateFrom).format(DateFormat)});
		}
		if(serviceEndDateTo !== null) {
			dataValue.push({key: 'ServiceEndDateTo', value: moment(serviceEndDateTo).format(DateFormat)});
		}
    dataValue.push({key: 'ShowInActivePTF', value: showInActivePTF});
    dataValue.push({key: 'PTFNumber', value: (ptfNumber === null || ptfNumber === '') ? '0' : ptfNumber});
    
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const serviceTypeId = _.cloneDeep(serviceType.map((x) => x.serviceTypeId));
    const clientId = _.cloneDeep(client.map((x) => x.clientId));
    const legalEntityId = _.cloneDeep(legalEntity.map((x) => x.customerId));
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const propertyTypeId = _.cloneDeep(propertyType.map((x) => x.propertyTypeId));
    const propertySubTypeId = _.cloneDeep(propertySubType.map((x) => x.propertyTypeId));
    const transitionTypeId = _.cloneDeep(transitionType.map((x) => x.transitionTypeId));
    const approvalStatusId = _.cloneDeep(approvalStatus.map((x) => x.approvalStatusId));

    dataValue.push({ key: 'MarketId', value: (marketId.join('|') === undefined || marketId.join('|') === '') ? '0' : marketId.join('|') });
    dataValue.push({ key: 'ServiceTypeId', value: (serviceTypeId.join('|') === undefined || serviceTypeId.join('|') === '') ? '0' : serviceTypeId.join('|') });
    dataValue.push({ key: 'ClientId', value: (clientId.join('|') === undefined || clientId.join('|') === '') ? '0' : clientId.join('|') });
    dataValue.push({ key: 'LegalentityId', value: (legalEntityId.join('|') === undefined || legalEntityId.join('|') === '') ? '0' : legalEntityId.join('|') });
    dataValue.push({ key: 'PropertyId', value: (propertyId.join('|') === undefined || propertyId.join('|') === '') ? '0' : propertyId.join('|') });
    dataValue.push({ key: 'PropertyTypeId', value: (propertyTypeId.join('|') === undefined || propertyTypeId.join('|') === '') ? '0' : propertyTypeId.join('|') });
    dataValue.push({ key: 'PropertySubTypeId', value: (propertySubTypeId.join('|') === undefined || propertySubTypeId.join('|') === '') ? '0' : propertySubTypeId.join('|') });
    dataValue.push({ key: 'TransitionTypeId', value: (transitionTypeId.join('|') === undefined || transitionTypeId.join('|') === '') ? '0' : transitionTypeId.join('|') });
    dataValue.push({ key: 'ApprovalStatusId', value: (approvalStatusId.join('|') === undefined || approvalStatusId.join('|') === '') ? '0' : approvalStatusId.join('|') });
        
    const url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'PTF%20Detail%20Report', type);
		// const url = GenerateAbsoluteURL(dataValue, [], 'PTF%20Detail%20Report', type);
    const uploadingKey = generateString(6);

    downloadReport(
      url,
      'PTF Detail Report',
      fileMimeType,
      type,
      isPrint
    );    
  }

	// Get Table Row data with formatted values
  getTableRow = (reportData) => {    
    let returnRows = [];

    returnRows = [...returnRows, ...this.renderTableRow(
      orderBy(reportData, this.state.orderBy, this.state.order)
    )];
    return returnRows;
  }

  // separate Property Address field from Property Name
  separatePropertyAddress = (reportData) => {
    (reportData || []).forEach(row => {
      row.propertyAddress = row.propertyName;
      row.propertyName = row.propertyName === null ? null : this.getDifferentProperties(row.propertyName);
    })
    return reportData;
  }

  // get different property names from property string
  getDifferentProperties = (propertyName) => {
    try {
      const propertyWiseData = propertyName.split('|');
      var propertyNames = [];
      (propertyWiseData || []).forEach((propertyData) => {  
        propertyNames.push((propertyData || '').split(':')[0]?.trim());
      });
    } catch(e){
      // log(e);
    }    
    return propertyNames.join('|');
  }

  // get Property Address table data of selected PTF
  getPropertyAddressTabledata = (propertyAddressData) => {
    const tableData = [];
    const propertyWiseData = propertyAddressData.split('|');
    (propertyWiseData|| []).forEach((propertyData) => {      
      const propName = propertyData.split(':')[0]?.trim();
      const address = (((propertyData.split(':')[1]).split(';')[0]).split('-')[1])?.trim();
      const city = (((propertyData.split(':')[1]).split(';')[1]).split('-')[1])?.trim();
      const state = (((propertyData.split(':')[1]).split(';')[2]).split('-')[1])?.trim();
      const zipCode = (((propertyData.split(':')[1]).split(';')[3]).split('-')[1])?.trim();
      let record = {propertyName: propName, propertyAddress: address, propertyCity: city, propertyState: state, propertyZipcode: zipCode};
      tableData.push(record);
    });
    return tableData;
  }

  // get Management Fee table data of selected PTF
  getManagementFeeTabledata = (managementFeeData) => {
    const tableData = [];
    const propertyWiseData = managementFeeData.split('|');
    (propertyWiseData|| []).forEach((propertyData) => {      
      const propName = propertyData.split(':')[0]?.trim();
      const minFee = (((propertyData.split(':')[1]).split(';')[0]).split('-')[1])?.trim().replace('$','');
      const flatFee = (((propertyData.split(':')[1]).split(';')[1]).split('-')[1])?.trim().replace('$','');
      const feePercent = (((propertyData.split(':')[1]).split(';')[2]).split('-')[1])?.trim().replace('%','');
      const sdate = (((propertyData.split(':')[1]).split(';')[3]).split('-')[1])?.trim();
      let record = {managementPropertyName: propName, feePercentage: feePercent, flatFee: flatFee, minimumFee: minFee, startdate: sdate};
      tableData.push(record);
    });
    return tableData;
  }

  // get Expense Details table data of selected PTF
  getBillableExpenseTabledata = (expenseDetails) => {
    const tableData = [];
    const propertyWiseData = expenseDetails.split('|');
    (propertyWiseData|| []).forEach((propertyData) => {      
      const propName = propertyData.split(':')[0]?.trim();
      const expenses = (propertyData.split(':')[1])?.trim().replaceAll(';','|');
      let record = {expensesBillablePropertyName: propName, expenseName: expenses};
      tableData.push(record);
    });
    return tableData;
  }

	// Render method to render components based on selected filters
  render() {
    const {
      showMain,
      reportData,
      serviceStartDateFrom,
      serviceStartDateTo,
			serviceEndDateFrom,
			serviceEndDateTo,
      marketMasterData,
      legalEntityMasterData,
      clientListingMasterData,
      propertyMasterData,
      transitionTypeListingData,
      propertyTypeMasterData,
      propertySubTypeMasterData,
      serviceTypeMasterData,
      statusMasterData,
      showReport,
      advanceFilterConfig,
      openSlidingPanel,
      showInActivePTF,
      ptfNumber,
      rows,
      openDialog,
      dialogTitle
    } = this.state;

    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (legalEntityMasterData.find(x => x.customerName === 'All') === undefined) {
      legalEntityMasterData.unshift({ customerName: 'All' });
    }
    if (clientListingMasterData.find(x => x.clientName === 'All') === undefined) {
      clientListingMasterData.unshift({ clientName: 'All' });
    }
    if (propertyMasterData.find(x => x.propertyName === 'All') === undefined) {
      propertyMasterData.unshift({ propertyName: 'All' });
    }
    if (transitionTypeListingData.find(x => x.transitionTypeName === 'All') === undefined) {
      transitionTypeListingData.unshift({ transitionTypeName: 'All' });
    }
    if (propertyTypeMasterData.find(x => x.propertyTypeName === 'All') === undefined) {
      propertyTypeMasterData.unshift({ propertyTypeName: 'All' });
    }
    if (propertySubTypeMasterData.find(x => x.propertySubTypeName === 'All') === undefined) {
      propertySubTypeMasterData.unshift({ propertySubTypeName: 'All' });
    }
    if (serviceTypeMasterData.find(x => x.serviceType === 'All') === undefined) {
      serviceTypeMasterData.unshift({ serviceType: 'All' });
    }
    if (statusMasterData.find(x => x.approvalStatus === 'All') === undefined) {
      statusMasterData.unshift({ approvalStatus: 'All' });
    }

    // const rows = this.getTableRow(reportData);
    return (
      <div>
        {showMain
          ? (
            <Reports></Reports>
          )
          : (
            <>
              <PageHeader
                key={'PTF_Detail_Report'}
                title={'PTF Detail Report'}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                PTF Detail Report
            </PageHeader>
              <Grid
                container
                spacing={3}
                className="no-print"
                style={{ marginLeft: '10px' }}
              >
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      value={this.state.market}
                      onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                      id="tags-market"
                      options= {marketMasterData}
                      limitTags={2}
                      getOptionLabel={(option) => option.marketName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Market"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                        blurOnSelect
                        multiple
                        limitTags={1}
                        id="tags-property"
                        value={this.state.property}
                        options= {propertyMasterData}
                        onChange={(e, val) => this.handleChange(e, val, 'property', 'propertyName')}
                        getOptionLabel={(option) => option.propertyName}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Property Name"
                          />
                        )}
                      />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-transitionType"
                      value={this.state.transitionType}
                      options= {transitionTypeListingData}
                      getOptionLabel={(option) => option.transitionTypeName}
                      onChange={(e, val) => this.handleChange(e, val, 'transitionType', 'transitionTypeName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Transition Type"
                        />
                        )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-client"
                      value={this.state.client}
                      options= {clientListingMasterData}
                      getOptionLabel={(option) => option.clientName}
                      onChange={(e, val) => this.handleChange(e, val, 'client', 'clientName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Client"
                        />
                        )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                        blurOnSelect
                        multiple
                        limitTags={1}
                        id="tags-propertyType"
                        value={this.state.propertyType}
                        options= {propertyTypeMasterData}
                        onChange={(e, val) => this.handleChange(e, val, 'propertyType', 'propertyTypeName')}
                        getOptionLabel={(option) => option.propertyTypeName}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Property Type"
                          />
                        )}
                      />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                        blurOnSelect
                        multiple
                        limitTags={1}
                        id="tags-approvalStatus"
                        value={this.state.approvalStatus}
                        options= {statusMasterData}
                        onChange={(e, val) => this.handleChange(e, val, 'approvalStatus', 'approvalStatus')}
                        getOptionLabel={(option) => option.approvalStatus}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Status"
                          />
                        )}
                      />
                  </Grid>
								</Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                        multiple
                        limitTags={1}
                        blurOnSelect
                        id="tags-legalEntity"
                        options={legalEntityMasterData}
                        value={this.state.legalEntity}
                        getOptionLabel={(option) => option.customerName}
                        onChange={(e, val) =>
                          this.handleChange(e, val, 'legalEntity', 'customerName')
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Legal Entity"                        
                          />
                        )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                        blurOnSelect
                        multiple
                        limitTags={1}
                        id="tags-propertySubType"
                        value={this.state.propertySubType}
                        options= {propertySubTypeMasterData}
                        onChange={(e, val) => this.handleChange(e, val, 'propertySubType', 'propertySubTypeName')}
                        getOptionLabel={(option) => option.propertySubTypeName}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Property Sub Type"
                          />
                        )}
                      />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                        blurOnSelect
                        multiple
                        limitTags={1}
                        id="tags-serviceType"
                        value={this.state.serviceType}
                        options={serviceTypeMasterData}
                        onChange={(e, val) => this.handleChange(e, val, 'serviceType', 'serviceType')}
                        getOptionLabel={(option) => option.serviceType}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Service Type"
                          />
                        )}
                      />
                  </Grid>                  
								</Grid>                
                <Grid item xs={12} lg={2} style={{ marginTop: '9px' }}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog_start_from"
                        label="Service Start Date From"
                        format="MM/dd/yyyy"
                        name="serviceStartDateFrom"
                        value={serviceStartDateFrom}
                        onChange={(e) => this.handleDateChange(e, 'serviceStartDateFrom')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container style={{ marginTop: '6px' }}>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog_start_to"
                        label="Service Start Date To"
                        format="MM/dd/yyyy"
                        name="serviceStartDateTo"
                        minDate={serviceStartDateFrom}
                        value={serviceStartDateTo}
                        onChange={(e) => this.handleDateChange(e, 'serviceStartDateTo')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <Grid item xs={12} style={{ marginTop: '11px' }}>
                    <TextField
                      id='ptf_number_id'
                      label='PTF Number'
                      fullWidth
                      size="small"
                      value={ptfNumber}
                      onChange={(event, value) => {
                        if ((event.target.value || '')?.trim() === '') {
                          this.onChangePTFNumber(event, '');
                        } else if (!isNaN(event.target.value) && event.target.value.length < 10) {
                          this.onChangePTFNumber(event, parseInt(event.target.value));
                        }
                      }}
                    >                      
                    </TextField>
                  </Grid> 
                </Grid>
								<Grid item xs={12} lg={2} style={{ marginTop: '9px' }}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog_end_from"
                        label="Service End Date From"
                        format="MM/dd/yyyy"
                        name="serviceEndDateFrom"
                        value={serviceEndDateFrom}
                        minDate={serviceStartDateFrom}
                        onChange={(e) => this.handleDateChange(e, 'serviceEndDateFrom')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container style={{ marginTop: '6px' }}>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog_end_to"
                        label="Service End Date To"
                        format="MM/dd/yyyy"
                        name="serviceEndDateTo"
                        value={serviceEndDateTo}
                        minDate={serviceEndDateFrom}
                        onChange={(e) => this.handleDateChange(e, 'serviceEndDateTo')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        className="w-100"
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <Grid item xs={12} style={{ marginTop: '11px' }}>
                    <Switch
                      isChecked={showInActivePTF}
                      onChangeValues={(checked, key) => {
                        this.showHideInActivePTF(checked);
                      }}
                      id={'switch_show_inactive_ptfs'}
                      labelText={'Show InActive Property Transitions'}
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <AdvancedFilter
                  filterConfig={advanceFilterConfig}
                  onApplyFilter={this.onAddvanceFilterChange}
                  openSlidingPanel={openSlidingPanel}
                  handleClose={this.handleClose}
                />
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  downloadFile={this.downloadFile}
                  data={reportData}
                />
              </Grid>
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (reportData === null || reportData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {openDialog && (
                <Dialog open={openDialog} maxWidth="lg">
                  <AppBar style={{ position: 'relative', backgroundColor: '#064473' }}>
                    <Toolbar>
                      <Typography
                        variant="h6"
                        className="app-header-white"
                        style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                      >
                      {dialogTitle}
                      </Typography>
                      <IconButton
                        edge="start"
                        color="inherit"
                        onClick={() => {
                          this.setState({
                            openDialog: false,
                            dialogTitle: ''                            
                          });
                        }}
                        aria-label="close"
                      >
                        <IoMdCloseCircleOutline />
                      </IconButton>
                    </Toolbar>
                  </AppBar>
                  <div className="col-sm-12 end-sm margin20lr">
                    <PageHeader key={'dialog_details'} title={dialogTitle} >                    
                    </PageHeader>
                    <hr className="hr-custom" />                    
                  </div>
                  <div className="row table-list-container" style={{ marginBottom: '20px' }}>
                    <GridTable
                      key={'managementFeeBillableExpenseTable'}
                      columns={UpdateColumnWithConfiguration(
                        this.state.showPropertyDetails 
                          ? propertyColumnsPTFDetailReport
                          : (this.state.showManagementFeeDetails
                              ? readOnlyManagementFeeColumns.filter(x=> x.key != 'legalEntity')
                              : ExpenseColumns.filter(x=> x.name !== 'Action')),
                        []
                      )}
                      reload={this.state.reloadDialogTable}
                      config={{ showPager: false }}
                      data={ this.state.showPropertyDetails 
                            ? this.getPropertyAddressTabledata(this.state.propertyAddressData) 
                            : (this.state.showManagementFeeDetails 
                              ? this.getManagementFeeTabledata(this.state.propertyManagementFee) 
                              : this.getBillableExpenseTabledata(this.state.propertyBillableExpense))}
                    ></GridTable>
                  </div>     
                </Dialog>
              )}
              {showReport && (reportData == null || reportData?.length <= 0) && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {showReport && (
                <>
                  {reportData !== null && reportData?.length > 0 && (
										<TableWithPaginations
                      tableData={rows}
                      renderTable={this.renderTable}
                      order={this.state.order}
                      oBy={this.state.orderBy}
                    />
                  )}
                </>
              )}
            </>
          )}
      </div>
    );
  }
}